import { gql } from '@apollo/client/core'
import { useQuery } from '@vue/apollo-composable'
import { IListNodeNavigationResponse, IFavoritesQuery } from '@types'

const FIND_FAVORITES_QUERY = gql`
  query ListUserFatorites($userId: ID!) {
    listUserFatorites(userId: $userId) {
      payload {
        ... on NodeNavigationListResponse {
          nodeNavigationList {
            details {
              nature {
                purpose
                code
              }
            }
            id
            title
          }
        }
      }
      type
    }
  }
`

export const useFavoritesQuery = (variables: IFavoritesQuery) => {
  const query = useQuery<IListNodeNavigationResponse>(FIND_FAVORITES_QUERY, variables, {
    fetchPolicy: 'network-only'
  })
  return query
}
